export default "__VITE_ASSET__BT_312tq__"